module.exports = __webpack_public_path__ + "static/media/brasao_ceara.05c1e133.svg";